import { useContext, useState } from "react";

import { MaskedInput } from "~/components/TextInput";
import type { MedicalProtocol } from "~/modules/aerobicCapabilities/schema";
import { studentEvaluationDemoContext } from "~/pages/authenticated/personalTrainer/studentEvaluationDemo";

export const Medical: React.FC = () => {
	const { data } = useContext(studentEvaluationDemoContext);
	const [value] = useState<MedicalProtocol>({
		heartRate: data?.medical?.heartRate ?? 0,
		maxVO2Consumption: data?.medical?.maxVO2Consumption ?? 0,
	});

	return (
		<div className="flex gap-3">
			<MaskedInput
				mask="float"
				inputMode="numeric"
				label="Consumo Máximo de VO2"
				placeholder="0"
				value={value?.maxVO2Consumption}
				onChange={() => undefined}
			/>
			<MaskedInput
				mask="float"
				inputMode="numeric"
				label="Frequência Cardíaca Final (bpm)"
				placeholder="0"
				value={value?.heartRate}
				onChange={() => undefined}
			/>
		</div>
	);
};
